export const BASE_URL = "https://api.ede.finance";
